import * as React from "react";
import { SVGicon, svgIcons } from "./SVGicon";

export type IButtonIcons = "next" | "previous" | "close" | "info";

export interface IButtonProps extends React.Props<Button> {
    disabled?: boolean;
    className?: string;
    onClick?: (e: Event) => void;
    type?: "button" | "submit" | "reset";
    tabIndex?: number;
    icon?: IButtonIcons;
}

export class Button extends React.Component<IButtonProps, any> {
    private _buttonRef: HTMLButtonElement;

    constructor(props: IButtonProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <button
                type={this.props.type ? this.props.type : "button"}
                className={this.props.className}
                disabled={this.props.disabled}
                onClick={(e) => this.onClick(e)}
                ref={(btn: HTMLButtonElement) => (this._buttonRef = btn)}
                tabIndex={this.props.tabIndex}
            >
                {this.props.icon === "previous" && <SVGicon icon={svgIcons.chevronLeft} />}
                {this.props.icon === "info" && <SVGicon icon={svgIcons.info} />}

                {this.props.children}

                {this.props.icon === "next" && <SVGicon icon={svgIcons.chevronRight} />}
                {this.props.icon === "close" && <SVGicon icon={svgIcons.close} />}
            </button>
        );
    }

    private onClick(e: any): void {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    }
}
